module.exports = __webpack_public_path__ + "img/wedding-1-min.0ddf0227.png";